import DateObject from 'react-date-object'
import persian from 'react-date-object/calendars/persian'
import {getTehranWallClockDate} from './tehranTime'

const INVOICE_REGISTRATION_DEADLINE_DAYS = 12
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000

const normalizeDateDigits = (value: string) =>
  value
    .replace(/[۰-۹]/g, (digit) => `${'۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)}`)
    .replace(/[٠-٩]/g, (digit) => `${'٠١٢٣٤٥٦٧٨٩'.indexOf(digit)}`)

const parsePersianInvoiceDate = (value?: string | null): Date | undefined => {
  const normalizedValue = normalizeDateDigits(`${value || ''}`)
  const parts = normalizedValue.match(/\d+/g)?.map(Number)

  if (!parts || parts.length < 3) return undefined

  const [year, month, day, hour = 0, minute = 0, second = 0] = parts
  const dateObject = new DateObject({calendar: persian, year, month, day, hour, minute, second})

  if (!dateObject.isValid) return undefined

  const date = dateObject.toDate()
  return Number.isNaN(date.getTime()) ? undefined : date
}

const getInvoiceDateAgeInDays = (
  value?: string | null,
  now: Date = getTehranWallClockDate()
) => {
  const invoiceDate = parsePersianInvoiceDate(value)
  if (!invoiceDate) return undefined

  return (now.getTime() - invoiceDate.getTime()) / MILLISECONDS_PER_DAY
}

const isInvoiceDatePastRegistrationDeadline = (
  value?: string | null,
  now: Date = getTehranWallClockDate(),
  deadlineDays = INVOICE_REGISTRATION_DEADLINE_DAYS
) => {
  const ageInDays = getInvoiceDateAgeInDays(value, now)
  return ageInDays !== undefined && ageInDays > deadlineDays
}

export {
  getInvoiceDateAgeInDays,
  INVOICE_REGISTRATION_DEADLINE_DAYS,
  isInvoiceDatePastRegistrationDeadline,
  parsePersianInvoiceDate,
}
